export default __webpack_public_path__ + "static/media/card_pull.9e8641cd.mp3";